// 報廢品庫存列表
<template>
  <div class="box">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div class="title">{{ language("scrapProductsInventory.title") }}</div>
    <template v-if="$menuList['SIS-Product-Discount-Inventory-Edit']">
      <div class="card_wrap">
        <div class="card">
          <batch-add-card :config="add" @success="updateData"></batch-add-card>
        </div>
        <div class="card">
          <batch-add-card :config="edit" @success="updateData"></batch-add-card>
        </div>
      </div>
    </template>

    <el-card shadow="never" v-loading="loading">
      <div slot="header" class="clearfix">
        <span
          ><h4>{{ language("productInventory.individualMode") }}</h4></span
        >
      </div>
      <div class="search">
        <cc-search
          :config="searchConfig"
          @doSearch="doSearch"
          size="medium"
        ></cc-search>
        <div class="count">
          <div>
            {{ language("productInventory.results") }}: {{ tableDataTotal }}
            {{ language("productInventory.rows") }}
          </div>
          <div class="page_wrap">
            <page
              @pageChange="pageChange"
              :total="tableDataTotal"
              ref="page"
            ></page>
          </div>
        </div>
        <div class="table">
          <edit-table :config="tableConfig" :tableData="tableData"></edit-table>

          <template v-if="$menuList['SIS-Product-Discount-Inventory-Edit']">
            <div class="button_wrap">
              <el-button type="primary" class="button" @click="save">{{
                language("productInventory.save")
              }}</el-button>
            </div>
          </template>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import page from "../../components/page";
import batchAddCard from "../../components/batchAddCard";
import editTable from "../../components/table";

export default {
  components: {
    breadcrumb,
    batchAddCard,
    page,
    editTable,
  },
  data() {
    return {
      loading: true,
      breadcrumb: {
        title: this.language("scrapProductsInventory.breadcrumbTitle"),
        list: [
          {
            name: this.language("scrapProductsInventory.breadcrumbList_1"),
          },
          {
            name: this.language("scrapProductsInventory.breadcrumbList_2"),
          },
        ],
      },
      shopNum: "", ///需要修改微動態
      add: {
        fileType: {
          1: ".xlsx",
        },
        form: { shopNum: "", type: 1 },
        request: "/admin/merchant/inventory/uploadFile",
        title: this.language("productInventory.step1Title"),
        setp1: {
          title: this.language("productInventory.step") + "1",
          temUrl: "/admin/merchant/inventory/downloadTemplate?isDiscount=1",
          text: this.language("productInventory.addStep1Text"),
          button: this.language("productInventory.download"),
        },
        setp2: {
          title: this.language("productInventory.step") + "2",
          text: this.language("productInventory.addStep2Text"),
          formName: "file",
        },
        stepButton: this.language("productInventory.stepButton"),
        type: "other",
      },

      edit: {
        type: "other",
        fileType: {
          1: ".xlsx",
        },
        form: { shopNum: "", type: 2 },
        request: "/admin/merchant/inventory/uploadFile",
        title: this.language("productInventory.step2Title"),
        setp1: {
          temUrl: "/admin/merchant/inventory/download",
          title: this.language("productInventory.step") + "1",
          text: this.language("scrapProductsInventory.editStep1Text"),
          button: this.language("productInventory.download"),
        },
        setp2: {
          title: this.language("productInventory.step") + "2",
          text: this.language("scrapProductsInventory.editStep2Text"),
          formName: "file",
        },
        stepButton: this.language("productInventory.stepButton"),
      },

      searchConfig: [
        {
          title: this.language("productInventory.searchTitle1"),
          displayName: "",
          fieldName: "barcode",
          style: "text",
        },
        {
          title: this.language("productInventory.searchTitle2"),
          displayName: "",
          fieldName: "mchProductId",
          style: "text",
        },
        {
          title: this.language("productInventory.searchTitle3"),
          displayName: "",
          fieldName: "name",
          style: "text",
        },
        // {
        //   title: this.language("scrapProducts.scrapProducts"),
        //   fieldName: "isDiscount",
        //   style: "select",
        //   displayName: "",
        //   options: [
        //     {
        //       label: "是",
        //       value: "1",
        //     },
        //     {
        //       label: "否",
        //       value: "0",
        //     },
        //   ],
        // },
      ],
      form: {},

      tableConfig: {
        columns: [
          {
            prop: "productNum",
            lable: this.language("productInventory.productNum"),
            minWidth: 150,
          },
          {
            prop: "originalProductNum",
            lable: "Original Article Master",
            minWidth: 150,
          },
          // {
          //   prop: "isDiscount",
          //   lable: this.language("scrapProducts.scrapProducts"),
          //   minWidth: 100,
          //   type: "tag",
          //   options: {
          //     1: {
          //       tagType: "success",
          //       text: "是",
          //     },
          //     0: {
          //       tagType: "info",
          //       text: "否",
          //     },
          //   },
          // },
          {
            prop: "barcode",
            lable: this.language("productInventory.tableColumn2"),
            minWidth: 150,
          },
          {
            prop: "mchProductId",
            minWidth: 160,
            lable: this.language("productInventory.tableColumn3"),
          },
          {
            prop: "name",
            lable: this.language("productInventory.tableColumn4"),
            minWidth: 170,
          },
          {
            prop: "stock",
            lable: this.language("productInventory.tableColumn5"),
            minWidth: 110,
          },
          {
            prop: "inProgress",
            lable: this.language("productInventory.tableColumn6"),
            minWidth: 110,
          },
          // {
          //   prop: "operate",
          //   lable: this.language("productInventory.tableColumn7"),
          //   type: "editSelect",
          //   minWidth: 150,

          //   options: [
          //     {
          //       value: "+",
          //       label: "+",
          //     },
          //     {
          //       value: "-",
          //       label: "-",
          //     },
          //   ],
          // },
          // {
          //   prop: "count",
          //   lable: this.language("productInventory.tableColumn8"),
          //   type: "editInput",
          //   minWidth: 180,
          // },
        ],
      },
      tableData: [],
      tableDataTotal: 0,
      oldTableData: [],
    };
  },
  methods: {
    pageChange(e) {
      this.form = {
        ...this.form,
        ...e,
        shopNum: this.shopNum,
        mchShopNum: this.shopNum,
      };
      this.getInentory(this.form);
    },
    doSearch(e) {
      let form = {
        barcode: e.barcode,
        mchProductId: e.mchProductId,
        name: e.name,
        shopNum: this.shopNum,
        mchShopNum: this.shopNum,
        pageSize: 10,
        pageNo: 1,
      };
      this.form = form;
      this.getInentory(this.form);
      this.$refs.page.init();
    },
    getInentory(from) {
      this.loading = true;
      this.ccRequest
        .do("admin/merchant/inventory/query?isDiscount=1", from)
        .then((res) => {
          this.loading = false;
          for (let i = 0; i < res.rows.length; i++) {
            res.rows[i].operate = "+";
            res.rows[i].count = "";
          }
          res.rows.forEach(v => {
            v.isDisabled = v.allowUpdate==0?true:false
          });

          this.tableData = [...res.rows];
          this.tableDataTotal = res.total;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
    save() {
      let data = [];
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].count != "") {
          data.push({
            count: this.tableData[i].count,
            id: this.tableData[i].id,
            operate: this.tableData[i].operate,
            isDiscount:this.tableData[i].isDiscount,
          });
        }
      }
      if (data.length == 0) {
        this.$message.error(
          this.language("productInventory.inventoryEmptyTips")
        );
        return false;
      }
      this.$confirm(
        this.language("batchAddCard.confirmText"),
        this.language("batchAddCard.tips"),
        {
          confirmButtonText: this.language("batchAddCard.confirm"),
          cancelButtonText: this.language("batchAddCard.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.ccRequest
            .do(
              "admin/merchant/inventory/batchUpdate",
              { items: data, shopNum: this.shopNum },
              "POSTJSON"
            )
            .then((res) => {
              this.$message({
                message: this.language("batchAddCard.success"),
                type: "success",
              });
              this.getInentory(this.form);
              this.editItems = [];
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateData() {
      this.form.pageSize = 10;
      this.form.pageNo = 1;
      this.getInentory({
        pageSize: 10,
        pageNo: 1,
        shopNum: this.shopNum,
        mchShopNum: this.shopNum,
      });
      this.$refs.page.init();
    },
  },
  mounted() {
      //如果是代管商店，则需要增加table显示，
    if (this.$shopData.isEscrow === 1) {
      //在inProgress后面 add/Deduct前
      this.tableConfig.columns.push({
        prop: "stockType",
        lable: this.language("productInventory.tableColumn9"),
         minWidth: 170,
         type: "tag",
          options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.onlyInStore"),
              },
              1: {
                tagType: "info",
                text: this.language("productDetails.inAndOutStore"),
              },
             
            },
      });
       this.tableConfig.columns.push({
        prop: "inStoreStocks",
        lable: this.language("productInventory.tableColumn10"),
         minWidth: 170,
      });
       this.tableConfig.columns.push({
        prop: "outOfStoreStocks",
        lable: this.language("productInventory.tableColumn11"),
         minWidth: 170,
      });
    }

    
    if (this.$menuList["SIS-Product-Discount-Inventory-Edit"]) {
      this.tableConfig.columns.push({
        prop: "operate",
        lable: this.language("productInventory.tableColumn7"),
        type: "editSelect",
        minWidth: 150,

        options: [
          {
            value: "+",
            label: "+",
          },
          {
            value: "-",
            label: "-",
          },
        ],
      });
      this.tableConfig.columns.push({
        prop: "count",
        lable: this.language("productInventory.tableColumn8"),
        type: "editInput",
        minWidth: 180,
      });
    }
    this.shopData = this.$shopData;
    this.shopNum = this.shopData.shopNum;
    this.add.form.shopNum = this.shopNum;
    this.edit.form.shopNum = this.shopNum;
    this.edit.setp1.temUrl += "?appId=supnr&shopNum=" + this.shopNum+"&isDiscount=1";
    this.form = { pageSize: 10, pageNo: 1, shopNum: this.shopNum };
    this.getInentory({
      pageSize: 10,
      pageNo: 1,
      shopNum: this.shopNum,
      mchShopNum: this.shopNum,
    });
  },
};
</script>
<style >
.search .el-card {
  border: none;
}
</style>
<style scoped lang="scss">
.box {
  height: 100%;
}
.card_wrap {
  display: flex;
  margin-bottom: 20px;
}
.card {
  margin-right: 20px;
  width: 100%;
}
.title {
  font-size: $sbuTitle;
  font-weight: 600;
  margin: 10px 0;
}
.count {
  // font-size: $sbuTitle;
  margin-bottom: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20px;
}
.table {
  padding: 0 20px;
}
.button_wrap {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  .button {
  }
}
.page_wrap {
  margin-left: 50px;
}
</style>